module.exports = __webpack_public_path__ + "img/dl.df643841.png";